import { useState, useEffect } from "react";
import "../src/assets/style/common.css";
import Home from "./views/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import LogoImg from "./assets/img/header/loader.webp";
import { UpArrowIcon } from "./components/common/Icons";
import { useScreenFixedProvider } from "./components/context/ScreenFixedProvider";

function App() {
  const [loading, setLoading] = useState(false);
  const { showOverlay } = useScreenFixedProvider();
  const [showButton, setShowButton] = useState(false);

  AOS.init({ once: true });
  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 3000);
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  useEffect(() => {
    if (showOverlay) {
      document.body.classList.add("setClass");
    } else {
      document.body.classList.remove("setClass");
    }
  }, [showOverlay]);
  return (
    <>
      {loading ? (
        <Home />
      ) : (
        <div className="h-100vh d-flex flex-column justify-content-center align-items-center">
          <img className="w-25" src={LogoImg} />
        </div>
      )}
      <>
        {showButton ? (
          <div
            className="topscroll d-flex justify-content-center align-items-center cursor-pointer"
            onClick={() => scrollToTop()}
          >
            <UpArrowIcon />
          </div>
        ) : (
          ""
        )}
      </>
    </>
  );
}

export default App;
